import StepConclusionsController from './stepConclusionsController';
import './stepConclusions.scss';

const StepConclusionsComponent = {
    template: require('./stepConclusionsView.html'),
    controller: StepConclusionsController,
};

StepConclusionsController.$inject = [
    '$mdDialog',
    'EvaluationService',
    'PedagogicalService',
    'UserService',
    '$q',
    '$stateParams',
    '$state',
    '$timeout',
];

export default StepConclusionsComponent;


// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepConclusions/stepConclusionsComponent.js